import _ from 'lodash';
import { ADMIN_TYPE, SECRETARIA_TYPE } from '@/helpers/roleTypes';

export default [
    {
        path: '',
        name: 'Admin - Elecciones',
        beforeEnter,
        meta: {
            access: [ADMIN_TYPE, SECRETARIA_TYPE],
        },
        component: () => import('@views/Admin/Elecciones'),
    },
    {
        path: 'eleccion/:eleccionId',
        name: 'Admin - Eleccion',
        beforeEnter,
        meta: {
            access: [ADMIN_TYPE, SECRETARIA_TYPE],
        },
        component: () => import('@views/Admin/Elecciones/eleccion'),
    },
    {
        path: '/contratos',
        name: 'Admin - Contratos',
        beforeEnter,
        meta: {
            access: [ADMIN_TYPE],
        },
        redirect: { name: 'Admin - Elecciones' },
        // component: () => import('@views/Admin/Contratos'),
    },
    {
        path: '/records',
        name: 'Admin - Records',
        beforeEnter,
        meta: {
            access: [ADMIN_TYPE, SECRETARIA_TYPE],
        },
        component: () => import('@views/Admin/Records'),
    },
    {
        path: '/reportes',
        name: 'Admin -reportes',
        component: () => import('@views/Admin/Reportes'),
        meta: { access: [ADMIN_TYPE, SECRETARIA_TYPE] },
    },

    {
        path: 'emails',
        name: 'emails',
        component: () => import('@views/Admin/Emails'),
        meta: { access: [ADMIN_TYPE] },
    },
    // {
    //     path: '/alumnos',
    //     component: () => import('@views/Admin/Alumnos'),
    //     children: [
    //         {
    //             path: '',
    //             name: 'Admin - Alumnos',
    //             beforeEnter,
    //             meta: {
    //                 access: [ADMIN_TYPE, SECRETARIA_TYPE, HELPDESK_TYPE],
    //             },
    //             component: () => import('@views/Admin/Alumnos/ListAlumnos'),
    //         },
    //     ],
    // },
    // {
    //     path: '/academicos',
    //     component: () => import('@views/Admin/Academicos'),
    //     children: [
    //         {
    //             path: '',
    //             name: 'Admin - Academicos',
    //             beforeEnter,
    //             meta: {
    //                 access: [ADMIN_TYPE, SECRETARIA_TYPE, HELPDESK_TYPE],
    //             },
    //             component: () => import('@views/Admin/Academicos/ListAcademicos'),
    //         },
    //     ],
    // },
    {
        path: '/votos/:eleccion_id',
        name: 'Admin - Votos',
        beforeEnter,
        meta: {
            access: [ADMIN_TYPE, SECRETARIA_TYPE],
        },
        component: () => import('@views/Admin/Votos'),
    },
    {
        path: 'mesas-de-votacion',
        name: 'Admin - vote stations',
        component: () => import('@views/Admin/Mesas'),
        meta: { access: [ADMIN_TYPE, SECRETARIA_TYPE] },
    },
];

import store from '@/store';

function beforeEnter(to, from, next) {
    const mode = _.get(store, 'getters.user.mode');
    const access = _.get(to, 'meta.access');

    if (access && Array.isArray(access)) {
        if (access.includes(mode)) {
            return next();
        } else if (from) {
            return next(from.path);
        } else {
            console.log('Unforbidden access');
        }
    }

    next('/login');
}
